import React from "react";
import { Quotation } from "../../../../../stores/CoursePreviewStore/Types";
import { savingPercent } from "../../../service";
import AppliedVoucher from "../AppliedVoucher";
import PriceAmount from "../PriceAmount";

interface Props {
  activeQuote: Quotation;
  couponCode: string;
  refCode: string;
  refreshQuoteWithoutCoupon: (e: any) => void;
}

const Yearly: React.FC<Props> = ({
  activeQuote,
  couponCode,
  refCode,
  refreshQuoteWithoutCoupon,
}) => {
  // Paying the year in one go is cheaper than twelve instalments, and the
  // quote says by how much. Laid out the way the single-course summary lays
  // out its own pay-in-full saving, so the two checkouts read alike.
  const saving = savingPercent(activeQuote);
  const showSaving = Boolean(
    activeQuote?.discounted &&
      saving > 0 &&
      activeQuote?.original_price?.formatted_amount,
  );

  return (
    <>
      <div id="priceBreakdown">
        <div className="price-line">
          <span>Annual pass</span>
          <PriceAmount quote={activeQuote} />
        </div>
        <AppliedVoucher
          couponCode={couponCode}
          refCode={refCode}
          refreshQuoteWithoutCoupon={refreshQuoteWithoutCoupon}
        />
        <div className="price-line total">
          <span>Today's charge</span>
          <div className="price-right">
            <PriceAmount quote={activeQuote} showDiscountComparison={false} />
            <div className="discount-note" style={{ color: "#C4841D" }}>
              {showSaving ? `One-off, save` : "One-off"}
            </div>
          </div>
        </div>
      </div>
      <div className="whats-included" id="whatsIncluded">
        <h4>What you get</h4>
        <ul>
          <li>All 40+ CPD-accredited Mini MBA courses</li>
          <li>Community Hub access</li>
          <li>AI toolkit and swipe file</li>
          <li>New courses as they launch</li>
          <li>Price locked in, never goes up while you stay subscribed</li>
        </ul>
      </div>
    </>
  );
};

export default Yearly;
